import { supabase } from '../supabase';

/**
 * Fetches venue data by ID
 * @param {string|number} venueId - The venue ID to fetch data for
 * @returns {Promise<Object>} - A promise that resolves to the venue data or null
 */
export const fetchVenueData = async (venueId) => {
  if (!venueId) return null;
  
  try {
    const { data, error } = await supabase
      .from('venues')
      .select('*')
      .eq('id', venueId)
      .single();

    if (error) {
      console.error('Error fetching venue data:', error);
      return null;
    }

    return data;
  } catch (err) {
    console.error('Exception when fetching venue data:', err);
    return null;
  }
}; 